<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Cancellation Reasons</span>
    </template>
    <b-container>
      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save Cancellation Reasons Changes
        </b-button>
        <b-button
          variant="primary"
          class="mb-2"
          @click="addNewCancellationForm"
        >
          <span>Add new cancellation reason</span>

        </b-button>
      </div>

      <validation-observer
        v-for="(el, index) in cancellationArr"
        :key="el.localId"
        :ref="`cancellationRef-${el.localId}`"
      >
        <b-form>
          <b-row
            class="pb-5 cancellations_form_style"
          >
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteCancellationForm(index)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="label"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Label"
                  :label-for="`label${el.localId}`"
                >
                  <b-form-input
                    :id="`label${el.localId}`"
                    v-model="el.label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="operator"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Operator"
                  :label-for="`operator${el.localId}`"
                >
                  <v-select
                    :id="`operator${el.localId}`"
                    v-model="el.operator"
                    :options="operators"
                    :reduce="operator => operator.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="state"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="State"
                  :label-for="`state${el.localId}`"
                >
                  <v-select
                    :id="`state${el.localId}`"
                    v-model="el.state"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <div
                class="d-flex justify-content-between"
              >
                <div>
                  <p>Driver</p>
                  <b-form-checkbox
                    v-model="el.driver"
                    :disabled="el.admin"
                  />
                </div>
                <div>
                  <p>User</p>
                  <b-form-checkbox
                    v-model="el.user"
                    :disabled="el.admin"
                  />
                </div>
                <div>
                  <p>Admin</p>
                  <b-form-checkbox
                    v-model="el.admin"
                    @change="() => { el.admin ? (el.user = false, el.driver = false, el.active = true) : '' }"
                  />
                </div>
                <div>
                  <p>Active</p>
                  <b-form-checkbox v-model="el.active" />
                </div>
              </div>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="duration"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Duration"
                  :label-for="`duration${el.localId}`"
                >
                  <b-form-input
                    :id="`duration${el.localId}`"
                    v-model="el.duration_value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <hr>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BButton, BFormCheckbox, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { v4 as uuidv4 } from 'uuid'
import { tripStates, operators } from '../../hooks/useStaticOptions'
import { errorNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'

export default {
  components: {
    BTab,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BButton,
    BFormCheckbox,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
  },
  props: {
    cancellationReasons: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const cancellationArr = ref(props.cancellationReasons.map(el => ({ ...el, localId: Math.random().toString() })))

    const addNewCancellationForm = () => {
      const tempCancel = {
        localId: Math.random().toString(),
        label: '',
        state: '',
        duration_value: '',
        operator: '',
        driver: '',
        user: '',
        admin: '',
        active: '',
        id: uuidv4(),
      }
      cancellationArr.value.unshift(tempCancel)
    }
    const deleteCancellationForm = index => {
      cancellationArr.value.splice(index, 1)
    }

    const validateForm = async () => {
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('cancellations-set', cancellationArr.value)
        ctx.emit('apply-cancellations')
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      operators,
      validateForm,
      addNewCancellationForm,
      deleteCancellationForm,
      cancellationArr,
    }
  },
}
</script>

<style scoped>
.cancellations_form_style{
    border: 3px solid lightgray;
    padding: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
}
</style>
